import _objectSpread from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import api from '@/api';
import EditSex from '../assembly/editSex/index';
import EditBirthday from '../assembly/editBirthday/index';
import EditVaus from '../assembly/editVAu/index';
import SelectData from '../assembly/selectData/index';
import SelectMemberPushMessages from '../assembly/selectPushMessages/index';
import MemberFreezeRecords from '../../memberFreezeRecords/edit/index';
export default {
  components: {
    EditSex: EditSex,
    EditBirthday: EditBirthday,
    EditVaus: EditVaus,
    SelectData: SelectData,
    SelectMemberPushMessages: SelectMemberPushMessages,
    MemberFreezeRecords: MemberFreezeRecords
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MemberEdit',
  data: function data() {
    return {
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      isUpdateInfo1: this.checkauthority('update_sex_info'),
      isUpdateInfo2: this.checkauthority('update_bosdy_info'),
      isUpdateInfo3: this.checkauthority('add_v_auth_info'),
      isUpdateInfo4: this.checkauthority('update_push_message_info_list'),
      isUpdateInfo5: this.checkauthority('member_info_user_data'),
      isUpdateInfo6: this.checkauthority('member_info_tuijian'),
      isUpdateInfo7: this.checkauthority('member_info_dongjie'),
      isUpdateInfo8: this.checkauthority('member_info_yongjiu_dongjie'),
      isUpdateInfo9: this.checkauthority('member_del'),
      freezeRecordsDialogVisible: false,
      freezeRecordsDisabled: false,
      editMemberInfoDialogVisible: false,
      editMemberInfoDisabled: false,
      selectDataDialogVisible: false,
      selectDataDisabled: true,
      editVauDialogVisible: false,
      editVauDisabled: false,
      editBirthdayDialogVisible: false,
      editBirthdayDisabled: false,
      editSexDialogVisible: false,
      editSexDisabled: false,
      title: '',
      form: {
        memberId: null,
        nickName: '',
        sex: '',
        name: '',
        headUrl: '',
        phone: '',
        userName: '',
        passWord: '',
        wxMiniOpenid: '',
        loginTime: null,
        loginNum: null,
        loginDevice: '',
        province: '',
        city: '',
        area: '',
        longitude: '',
        latitude: '',
        vAuth: '',
        memberType: '',
        privateLetterNum: null,
        acceptNum: null,
        memberStartTime: null,
        memberEndTime: null,
        warningsNum: null,
        currencyNum: null,
        memberSts: null,
        createTime: null,
        memberNo: '',
        source: '',
        memberInfo: null,
        marriage: '',
        height: '',
        weight: '',
        homeTop: null,
        idNo: '',
        nativePlace: ''
      },
      sexs: [],
      marriages: [],
      educations: [],
      zodiacs: [],
      constellations: [],
      nations: [],
      politicalOutlooks: [],
      memberRankingAtHomes: [],
      memberOccupations: [],
      memberIndustrys: [],
      memberCompanyTypes: [],
      memberPosts: [],
      memberPostTypes: [],
      memberAnnualIncomes: [],
      memberSmokes: [],
      memberDrinks: [],
      carPurchases: [],
      buyHouses: [],
      pics: []
    };
  },
  methods: {
    ifPicUrl: function ifPicUrl(url) {
      if (url.indexOf('http') !== -1) {
        return url;
      }
      return this.downloadUrl + url;
    },
    permanentFreeze: function permanentFreeze() {
      var _this = this;
      this.$confirm('确定要永久冻结会员吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.updateFreeze();
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消冻结'
        });
      });
    },
    freezeRecordsInitData: function freezeRecordsInitData() {
      this.$emit('initTableData');
    },
    freezeRecordsOpen: function freezeRecordsOpen() {
      this.$refs.memberFreezeRecords.setTitle('冻结');
      this.$refs.memberFreezeRecords.setData(this.form);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsOpen2: function freezeRecordsOpen2() {
      this.$refs.memberFreezeRecords.setTitle('永久冻结');
      this.$refs.memberFreezeRecords.setData2(this.form);
      this.freezeRecordsDialogVisible = true;
    },
    freezeRecordsClose: function freezeRecordsClose() {
      this.freezeRecordsDialogVisible = false;
    },
    updateFreeze: function updateFreeze() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var pro;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              pro = {
                memberId: _this2.form.memberId,
                type: 2,
                remarks: '永久冻结'
              };
              _context.n = 1;
              return api.SAVE_MEMBERFREEZERECORDS(pro);
            case 1:
              _this2.$emit('initTableData');
              _this2.$message.success('操作成功');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    editMemberInfoDataInitData: function editMemberInfoDataInitData() {
      this.$emit('initTableData');
    },
    editMemberInfoOpen: function editMemberInfoOpen() {
      this.$refs.selectMemberPushMessages.setTitle('推送记录');
      this.$refs.selectMemberPushMessages.initTableData(this.form);
      this.editMemberInfoDialogVisible = true;
    },
    editMemberInfoClose: function editMemberInfoClose() {
      this.editMemberInfoDialogVisible = false;
    },
    selectDataInitData: function selectDataInitData() {
      this.$emit('initTableData');
    },
    selectDataOpen: function selectDataOpen() {
      this.$refs.selectData.setTitle('用户数据');
      this.$refs.selectData.getMemberDatas(this.form);
      this.selectDataDialogVisible = true;
    },
    selectDataClose: function selectDataClose() {
      this.selectDataDialogVisible = false;
    },
    editVauInitData: function editVauInitData() {
      this.$emit('initTableData');
    },
    editVauOpen: function editVauOpen() {
      this.$refs.editVau.setTitle('加V认证');
      this.$refs.editVau.setData(this.form);
      this.editVauDialogVisible = true;
    },
    editVauClose: function editVauClose() {
      this.editVauDialogVisible = false;
    },
    editBirthdayInitData: function editBirthdayInitData(time) {
      this.form.birthday = time;
      this.$emit('initTableData');
    },
    editBirthdayOpen: function editBirthdayOpen() {
      this.$refs.editBirthday.setTitle('修改出生日期');
      this.$refs.editBirthday.setData(this.form);
      this.editBirthdayDialogVisible = true;
    },
    editBirthdayClose: function editBirthdayClose() {
      this.editBirthdayDialogVisible = false;
    },
    editSexInitData: function editSexInitData(sex) {
      // this.form.sex = this.enums.checkEnumsValue(this.sexs, sex, '')
      this.form.sex = sex;
      this.$emit('initTableData');
    },
    editSexOpen: function editSexOpen() {
      this.$refs.editSex.setTitle('修改性别');
      this.$refs.editSex.setData(this.form);
      this.editSexDialogVisible = true;
    },
    editSexClose: function editSexClose() {
      this.editSexDialogVisible = false;
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par, res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                name: name
              };
              _context2.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context2.v;
              _this3.enumList = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.form.memberId = null;
      this.form.nickName = null;
      this.form.sex = null;
      this.form.name = null;
      this.form.headUrl = null;
      this.form.phone = null;
      this.form.userName = null;
      this.form.passWord = null;
      this.form.wxMiniOpenid = null;
      this.form.loginTime = null;
      this.form.loginNum = null;
      this.form.loginDevice = null;
      this.form.province = null;
      this.form.city = null;
      this.form.area = null;
      this.form.longitude = null;
      this.form.latitude = null;
      this.form.vAuth = null;
      this.form.memberType = null;
      this.form.privateLetterNum = null;
      this.form.acceptNum = null;
      this.form.memberStartTime = null;
      this.form.memberEndTime = null;
      this.form.warningsNum = null;
      this.form.currencyNum = null;
      this.form.memberSts = null;
      this.form.createTime = null;
      this.form.memberNo = null;
      this.form.source = null;
      this.form.memberInfo = null;
      this.form.homeTop = 0;
    },
    setData: function setData(data) {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.getEnumsApi();
      this.form = {};
      this.getMemberInfoApi(data.memberId, data);
    },
    getEnumsApi: function getEnumsApi() {
      var thiz = this;
      this.enums.sexEnums(function (arg) {
        thiz.sexs = arg.body;
      });
      this.enums.getMbmberMarriages(function (arg) {
        thiz.marriages = arg.body;
      });
      this.enums.getEducations(function (arg) {
        thiz.educations = arg.body;
      });
      this.enums.getZodiacs(function (arg) {
        thiz.zodiacs = arg.body;
      });
      this.enums.getConstellations(function (arg) {
        thiz.constellations = arg.body;
      });
      this.enums.getNations(function (arg) {
        thiz.nations = arg.body;
      });
      thiz.enums.getMemberPoliticalOutlooks(function (arg) {
        thiz.politicalOutlooks = arg.body;
      });
      this.enums.getMemberRankingAtHomes(function (arg) {
        thiz.memberRankingAtHomes = arg.body;
      });
      this.enums.getMemberOccupations(function (arg) {
        thiz.memberOccupations = arg.body;
      });
      this.enums.getMemberIndustrys(function (arg) {
        thiz.memberIndustrys = arg.body;
      });
      this.enums.getMemberCompanyTypes(function (arg) {
        thiz.memberCompanyTypes = arg.body;
      });
      this.enums.getMemberPosts(function (arg) {
        thiz.memberPosts = arg.body;
      });
      this.enums.getMemberPostTypes(function (arg) {
        thiz.memberPostTypes = arg.body;
      });
      this.enums.getMemberAnnualIncomes(function (arg) {
        thiz.memberAnnualIncomes = arg.body;
      });
      this.enums.getMemberSmokes(function (arg) {
        thiz.memberSmokes = arg.body;
      });
      this.enums.getMemberDrinks(function (arg) {
        thiz.memberDrinks = arg.body;
      });
      this.enums.getBuyHouse(function (arg) {
        thiz.buyHouses = arg.body;
      });
      this.enums.getCarPurchase(function (arg) {
        thiz.carPurchases = arg.body;
      });
    },
    getMemberInfoApi: function getMemberInfoApi(memberId, data) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var pro, ls, res, idNoReg;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              pro = {
                memberId: memberId
              };
              ls = _objectSpread({}, data);
              _context3.n = 1;
              return api.GET_MEMBERINFO_INFO(pro);
            case 1:
              res = _context3.v;
              _this4.getPicsApi(memberId);
              res.body.height = res.body.height + 'cm';
              res.body.weight = res.body.weight + 'kg';
              res.body.nation = _this4.enums.checkEnumsValue(_this4.nations, res.body.nation, '');
              res.body.constellation = _this4.enums.checkEnumsValue(_this4.constellations, res.body.constellation, '');
              res.body.politicalOutlook = _this4.enums.checkEnumsValue(_this4.politicalOutlooks, res.body.politicalOutlook, '');
              res.body.rankingAtHome = _this4.enums.checkEnumsValue(_this4.memberRankingAtHomes, res.body.rankingAtHome, '');
              // res.body.occupation = this.enums.checkEnumsValue(this.memberOccupations, res.body.occupation, '')
              res.body.industry = _this4.enums.checkEnumsValue(_this4.memberIndustrys, res.body.industry, '');
              res.body.companyType = _this4.enums.checkEnumsValue(_this4.memberCompanyTypes, res.body.companyType, '');
              res.body.postNature = _this4.enums.checkEnumsValue(_this4.memberPostTypes, res.body.postNature, '');
              res.body.post = _this4.enums.checkEnumsValue(_this4.memberPosts, res.body.post, '');
              res.body.annualIncome = _this4.enums.checkEnumsValue(_this4.memberAnnualIncomes, res.body.annualIncome, '');
              res.body.smoke = _this4.enums.checkEnumsValue(_this4.memberSmokes, res.body.smoke, '');
              res.body.drink = _this4.enums.checkEnumsValue(_this4.memberDrinks, res.body.drink, '');
              console.log(ls.carPurchase);
              console.log(ls.buyHouse);
              idNoReg = /(\d{0})\d{6}(\d{6})/;
              if (ls.idNo.length === 18) {
                ls.idNo = ls.idNo.substring(0, ls.idNo.length - 4) + '****';
                ls.idNo = ls.idNo.replace(idNoReg, '$1******$2');
              }

              // ls.carPurchase = this.enums.checkEnumsValue(this.carPurchases, ls.carPurchase, '')
              // ls.buyHouse = this.enums.checkEnumsValue(this.buyHouses, ls.buyHouse, '')
              ls.city = JSON.stringify(ls.memberCitys);
              // ls.sex = this.enums.checkEnumsValue(this.sexs, ls.sex, '')
              // ls.marriage = this.enums.checkEnumsValue(this.marriages, ls.marriage, '')
              // ls.education = this.enums.checkEnumsValue(this.educations, ls.education, '')
              // res.body.zodiac = this.enums.checkEnumsValue(this.zodiacs, res.body.zodiac, '')
              _this4.form = Object.assign(ls, res.body);
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteMember: function deleteMember() {
      var _this5 = this;
      this.$confirm('确定要删除会员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.deleteMemberApi();
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteMemberApi: function deleteMemberApi() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var pro;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              pro = {
                memberId: _this6.form.memberId
              };
              _context4.n = 1;
              return api.DELETE_MEMBER(pro);
            case 1:
              _this6.$message.success('操作成功');
              _this6.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getPicsApi: function getPicsApi(memberId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var pro, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              pro = {
                memberId: memberId
              };
              _context5.n = 1;
              return api.GET_MEMBERPICTURES_LIST(pro);
            case 1:
              res = _context5.v;
              _this7.pics = res.body;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    updateHomeTopApi: function updateHomeTopApi(top) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var pro;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (top === 0) {
                top = 1;
              } else {
                top = 0;
              }
              pro = {
                memberId: _this8.form.memberId,
                homeTop: top
              };
              _this8.form.homeTop = top;
              _context6.n = 1;
              return api.UPDATE_MEMBER(pro);
            case 1:
              _this8.$emit('initTableData');
              _this8.$message.success('操作成功');
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    updateApi: function updateApi() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return api.UPDATE_MEMBER(_this9.form);
            case 1:
              _this9.$emit('initTableData');
              _this9.$message.success('操作成功');
              _this9.handleClose();
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    saveApi: function saveApi() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              _context8.n = 1;
              return api.SAVE_MEMBER(_this0.form);
            case 1:
              _this0.$emit('initTableData');
              _this0.$message.success('操作成功');
              _this0.handleClose();
            case 2:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    save: function save() {
      var _this1 = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this1.form.memberId != null) {
            _this1.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              _this1.updateApi();
            }).catch(function () {
              _this1.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this1.saveApi();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  }
};